module.exports = __webpack_public_path__ + "img/winners-rafiki.3433531b.svg";